import { createContext, useContext } from "react";
import { FixtureItem, MatchAnalysisItem } from "@api";
import { UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

type FixtureContextType = {
  source: UseQueryResult<AxiosResponse<MatchAnalysisItem>, Error>;
  fixture: FixtureItem;
};

const FixtureContext = createContext<FixtureContextType>({
  source: {} as UseQueryResult<AxiosResponse<MatchAnalysisItem>, Error>,
  fixture: {} as FixtureItem,
});

export const useFixtureContext = () => {
  const context = useContext(FixtureContext);
  if (!context) {
    throw new Error("useFixture must be used within a Fixture provider");
  }
  return context;
};

export const FixtureProvider = FixtureContext.Provider;
